import Vue from 'vue'
import chart from './chart.vue'
export default {
  functional: true,
  props: {
    item: {
      required: false,
      default: () => ({})
    }
  },
  render(createElement, context) {
    return createElement(chart, { ...context.data, props: context.props })
  }
}


